// extracted by mini-css-extract-plugin
export var checkbox = "_92-0";
export var circle = "_92-3";
export var horizontalContainer = "_92-7";
export var sm = "_92-5";
export var switch0 = "_92-2";
export var switchDisabled = "_92-8";
export var switchEnabled = "_92-1";
export var textSwitchContainer = "_92-9";
export var textSwitchOption = "_92-a";
export var textSwitchOptionSelected = "_92-b";
export var verticalContainer = "_92-6";
export var xs = "_92-4";